import LayoutComponent from "../components/LayoutComponent";
import {Button, Form, Input} from "antd";
import {useState, useEffect} from 'react';
import {useApi} from "../provider/ApiProvider";
import {useHistory} from "react-router-dom";
import CompanySelector from "../components/CompanySelector";
import TextEditor from "../components/TextEditor";
import ImageUpload from "../components/ImageUpload";

import { DatePicker, Space } from 'antd';
import CustomerSelector from "../components/CustomerSelector";
import moment from 'moment';
import FullLoader from "../components/FullLoader";
const { RangePicker } = DatePicker;
const dateFormatList = ['DD.MM.YYYY', 'DD.MM.YYYY'];
const dateFormat = 'DD.MM.YYYY';


// moment.locale('tr_TR');


const {TextArea} = Input;

export default function Notifications(props){
    const {api, successHandling} = useApi();
    let history = useHistory();

    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [imageData, setImageData] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);


    useEffect(() => {

        load();
    }, [])

    async function load(){

    }

    async function onChangeImageUpload(value){
        setImageData(value);
    }

    async function save(values){

        setLoading(true);
        await api.post('/notificationRouter/send',{
            CustomerId: values.CustomerId,
            title: values.title,
            message: values.content,
            PlatformId: values.PlatformId,

        }).then(resp => {
            successHandling("Bildirim başarıyla gönderildi");
            setLoading(false);

        }).finally(() => {
            setLoading(false);
        })
    }

    async function storeData(params, title, content){

    }

    async function updateData(id, params){

    }

    return (
        <LayoutComponent links={
            [
                {
                    title: 'Bildirim Gönder',
                    url: '/'
                },


            ]}
        >
            <div>
              <FullLoader show={loading}/>
                <Form
                    form={form}
                    name="basic"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={save}
                    onFinishFailed={() => {}}
                >

                    <Form.Item
                        label="Müşteri (Kuruluş)"
                        name="CustomerId"
                        rules={[
                            {
                                required: true,
                                message: 'Müşteri Seçiniz',
                            },
                        ]}
                    >
                        <CustomerSelector
                            value={form.getFieldValue('CustomerId')}
                            onChange={(value, found) =>{
                                form.setFieldsValue({ CustomerId: value })
                                setSelectedCustomer(found);
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Başlık"
                        name="title"
                        rules={[
                            {
                                required: true,
                                message: 'Başlık Giriniz',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Mesaj"
                        name="content"
                        rules={[
                            {
                                required: true,
                                message: 'Metin giriniz',
                            },
                        ]}
                    >
                        <Input/>
                    </Form.Item>

                    <div className="form-button">
                        <Button className="submit-btn" loading={loading}  type="primary" htmlType="submit">
                            Gönder
                        </Button>
                    </div>
                </Form>
            </div>
        </LayoutComponent>
    )
}
